import { render } from "./ImageExplainerEditorCmp.vue?vue&type=template&id=4f9ea39a"
import script from "./ImageExplainerEditorCmp.vue?vue&type=script&lang=js"
export * from "./ImageExplainerEditorCmp.vue?vue&type=script&lang=js"

import "./ImageExplainerEditorCmp.vue?vue&type=style&index=0&id=4f9ea39a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__